import {Component, Inject, OnInit, Optional, QueryList, ViewChildren} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { zip } from 'rxjs';

import { DocumentFormComponent } from '../document-form/document-form.component';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {PubSubService} from '../../../common/services/pub-sub.service';
import {typeEvents} from '../../../common/enum/type-events';

@Component({
  selector: 'p8-bdc-document-new',
  templateUrl: './document-new.component.html',
  styleUrls: ['./document-new.component.scss']
})
export class DocumentNewComponent implements OnInit {
  @ViewChildren(DocumentFormComponent) documentFormComponents:  QueryList<DocumentFormComponent>;

  files: File[] = [];

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRef: MatDialogRef<DocumentNewComponent>,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private pubSubSvc: PubSubService
  ) { }

  ngOnInit() {
  }

  remove(index: number) {
    this.files.splice(index, 1);
  }

  onSubmit() {
    const documentsToUpload$ = this.documentFormComponents.map(d => d.save());

    zip(...documentsToUpload$).subscribe(data => {
      this.pubSubSvc.publish(typeEvents.docSaved, 'Les documents ont bien été ajoutés');
      if (this.dialogRef) {
        this.dialogRef.close(true);
      } else {
        this.router.navigate(['..'], {relativeTo: this.activatedRoute});
      }
    });
  }

  onCancel() {
    this.router.navigate(['..'], {relativeTo: this.activatedRoute});
  }

  isValid(): boolean {
    return this.files.length > 0;
  }
}
